import React, { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import useSavedGroups from "./useSavedGroups";

const SavedGroupsStateContext = createContext(null);
const SavedGroupsActionsContext = createContext(null);

export function SavedGroupsProvider({ children }) {
  const {
    state,
    reload,
    createGroup,
    updateGroup,
    addToGroup,
    removeFromGroup,
    destroyGroup,
    isSaved,
    membershipsFor,
  } = useSavedGroups();

  const actions = useMemo(
    () => ({ reload, createGroup, updateGroup, addToGroup, removeFromGroup, destroyGroup, isSaved, membershipsFor }),
    [reload, createGroup, updateGroup, addToGroup, removeFromGroup, destroyGroup, isSaved, membershipsFor],
  );

  return (
    <SavedGroupsStateContext.Provider value={state}>
      <SavedGroupsActionsContext.Provider value={actions}>{children}</SavedGroupsActionsContext.Provider>
    </SavedGroupsStateContext.Provider>
  );
}

SavedGroupsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export function useSavedGroupsState() {
  return useContext(SavedGroupsStateContext);
}

// Actions are stable callbacks (useCallback with [] deps). isSaved() and membershipsFor()
// read from a ref so they're always current, but they are snapshot helpers — not reactive.
// For derived values that should re-render when membership changes, consume useSavedGroupsState()
// directly rather than calling these inside useMemo/useEffect dependency arrays.
export function useSavedGroupsActions() {
  return useContext(SavedGroupsActionsContext);
}
